export class FileDropOverlay {
  constructor(options = {}) {
    // Default options
    this.options = {
      parentElement: document.body,
      hiddenClass: 'hidden',
      onDrop: null,
      svgSize: 80,
      message: 'Drop files to upload',
      ...options,
    }

    this.dragCounter = 0
    this.overlay = null

    // Bind methods to maintain 'this' context
    this.dragEnter = this.dragEnter.bind(this)
    this.dragOver = this.dragOver.bind(this)
    this.dragLeave = this.dragLeave.bind(this)
    this.drop = this.drop.bind(this)

    // Create overlay and initialize
    this.createOverlay()
    this.attachEvents()
  }

  createOverlay() {
    const overlayHTML = `
      <div class="absolute left-0 top-0 z-40 w-full h-full justify-center items-center hidden" id="dropOver">
        <div class="flex w-full h-full justify-center items-center bg-black bg-opacity-50">
          <div class="flex-row z-10 justify-center text-center">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="text-white w-full h-20"><polyline points="16 16 12 12 8 16"></polyline><line x1="12" y1="12" x2="12" y2="21"></line><path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"></path><polyline points="16 16 12 12 8 16"></svg>
            <div class="text-md text-white">
              ${this.options.message}
            </div>
          </div>
        </div>
      </div>
    `

    this.options.parentElement.insertAdjacentHTML('beforeend', overlayHTML)
    this.overlay = this.options.parentElement.querySelector('#dropOver')
  }

  attachEvents() {
    document.addEventListener('dragenter', this.dragEnter)
    document.addEventListener('dragover', this.dragOver)
    document.addEventListener('dragleave', this.dragLeave)
    document.addEventListener('drop', this.drop)
  }

  detachEvents() {
    document.removeEventListener('dragenter', this.dragEnter)
    document.removeEventListener('dragover', this.dragOver)
    document.removeEventListener('dragleave', this.dragLeave)
    document.removeEventListener('drop', this.drop)
  }

  dragEnter(event) {
    event.preventDefault()
    this.dragCounter++
    if (this.dragCounter === 1) {
      this.overlay.classList.remove(this.options.hiddenClass)
    }
  }

  dragOver(event) {
    event.preventDefault()
  }

  dragLeave(event) {
    event.preventDefault()
    this.dragCounter--
    setTimeout(() => {
      if (this.dragCounter === 0) {
        this.overlay.classList.add(this.options.hiddenClass)
      }
    }, 50)
  }

  drop(event) {
    event.preventDefault()
    this.dragCounter = 0
    this.overlay.classList.add(this.options.hiddenClass)

    if (event.dataTransfer.files.length > 0 && typeof this.options.onDrop === 'function') {
      this.options.onDrop(event.dataTransfer.files)
    }
  }

  destroy() {
    this.detachEvents()
    if (this.overlay && this.overlay.parentNode) {
      this.overlay.parentNode.removeChild(this.overlay)
      this.overlay = null
    }
  }
}
